import type { JSX } from 'react';

import { CheckCircleIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

type ToastProps = {
	message: string;
};

export function Toast({ message }: ToastProps): JSX.Element {
	return (
		<div
			role="alert"
			aria-live="assertive"
			className="rounded-medium fixed left-1/2 z-20 flex inline-flex -translate-x-1/2 items-start items-center gap-[16px] border-[#497143] bg-[#528334] p-[16px] text-white opacity-100 transition-opacity duration-300 sm:bottom-[8px] sm:mt-auto sm:w-full sm:max-w-[calc(100%-2rem)] md:bottom-auto md:mt-[8px] md:w-auto"
		>
			<CheckCircleIcon size={24} className="text-white" />
			<Text className="pt-[2px] text-size-body font-bold text-white">{message}</Text>
		</div>
	);
}
